import React, { Component } from "react";
import { Button, DropdownButton, Glyphicon, MenuItem} from "react-bootstrap";
import getMeasureTitle from "../../utils/Measure";
import "../../css/form/DropdownTextTrainer.css";

export default class DropdownTextTrainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = { title: 'Select Measure' };
    }

    componentWillMount () {
        var id    = parseInt(this.props.id);
        this.changeDDIdAndTitle(id)
    }

    componentDidUpdate(previousProps, previousState) {
        var new_id = this.props.id;

        if(previousProps.id !== this.props.id) {

            var id = parseInt(new_id);
            this.changeDDIdAndTitle(id)
        }
    }

    changeDDIdAndTitle(id) {
        var title = getMeasureTitle(id);

        this.setState({
            id:    id,
            title: title,
        });
    }

    onSelect(event) {
        var id    = event[0];
        var title = event[1]
        console.log("id: " + id);
        console.log("title: " + title);
        /*this.setState({
            id:    id,
            title: title
        });

        this.props.changeId(id); // update id in parent
        */
        this.props.selection(title);
    }

    render() {
        var athleteName = this.props.athleteName;
        var programName = this.props.programName;

        var msg1 = "Please create a program for "+athleteName+".";
        var msg2 = "It’s been a while since " + athleteName + "'s program has been accessed. Why's that?";
        var msg3 = "When will " + athleteName + " be in next?";
        var msg4 = athleteName + " is almost done with " + programName + ". Please add their next program.";
        var msg5 = "Let's make some edits to "+ programName + ".";
        var msg6 = programName + ", looks great! Let’s save it is a template.";
        var msg7 = "Please make " + athleteName + ", a travel program.";

        return (
            <span className="trainerSendTextMessage">
                <DropdownButton id        = "DropdownMeasure"
                                onSelect  = {(event) => this.onSelect(event)}
                                title     = "Optional: Text Messages"
                                className = "dropdownMeasureCaret customButton dropdownTrainerSendTextMsg">
                           <MenuItem className = "dropdownMenuItemTrainerSendTextMsg"
                                     eventKey={["1", msg1]} name="">1. {msg1}</MenuItem>
                           <MenuItem className = "dropdownMenuItemTrainerSendTextMsg"
                                     eventKey={["2", msg2]} name="">
                               2. It’s been a while since {athleteName}’s program has been<br/>accessed. Why’s that?
                           </MenuItem>
                           <MenuItem className = "dropdownMenuItemTrainerSendTextMsg"
                                     eventKey={["3", msg3]} name="">3. {msg3}</MenuItem>
                           <MenuItem className = "dropdownMenuItemTrainerSendTextMsg"
                                     eventKey={["4", msg4]} name="">
                               4. {athleteName} is almost done with {programName}.<br/>Please add their next program.
                           </MenuItem>
                           <MenuItem className = "dropdownMenuItemTrainerSendTextMsg"
                                     eventKey={["5", msg5]} name="">5. {msg5}</MenuItem>
                           <MenuItem className = "dropdownMenuItemTrainerSendTextMsg"
                                     eventKey={["6", msg6]} name="">
                               6. {programName}, looks great!<br/>Let’s save it is a template.
                           </MenuItem>
                           <MenuItem className = "dropdownMenuItemTrainerSendTextMsg"
                                     eventKey={["7", msg7]} name="">7. {msg7}</MenuItem>
                 </DropdownButton>
            </span>
         );
     }

}



// WEBPACK FOOTER //
// ./src/components/form/DropdownTextTrainer.js